import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';

import { PageSubTitle, Loading } from 'components/common/Elements/Elements';

import { postRequest } from 'utils/requests';

import classes from './AdditionalContent.module.scss';

const AdditionalContent = ({ id }) => {
  const [loader, setLoader] = useState(true);
  const [jsonDataNetwork, setJsonDataNetwork] = useState({});

  useEffect(() => {
    let cancelled = false;
    id !== '' &&
      postRequest('/customer/platform/network/more', {
        networkId: id
      })
        .then(res => {
          !cancelled && setJsonDataNetwork(res.body);
          setLoader(false);
        })
        .catch(err => {
          !cancelled && console.log(err);
          setLoader(false);
        });
    return () => (cancelled = true);
  }, [id]);

  if (loader) {
    return <Loading />;
  }
  return (
    <>
      <PageSubTitle
        title={'Network Details:'}
        className={classes.title}
        classNameHeading={classes.heading}
        size={2}
      />

      <div className={classes.jsonInfoWraper}>
        <ReactJson
          src={jsonDataNetwork}
          iconStyle="triangle"
          enableClipboard={false}
          displayDataTypes={false}
          displayObjectSize={false}
          indentWidth={4}
          collapsed={false}
        />
      </div>
    </>
  );
};

AdditionalContent.propTypes = {
  id: PropTypes.string
};

export default AdditionalContent;
